export const DAFTAR_BACK_BASE_URL = process.env.VUE_APP_BASE_URL;